<template>
  <div id="random_offers">
      <random-section routing="offers" :error="error" :show="show" :data="info" v-if="staticCard"/>
      <slider-section id="normal-cards" routing="all-offers" :obj="offerSliderRepo" sliderHolder="randomOffers" method="get" :data="info" v-if="slider"/>
  </div>
</template>

<script>
import RandomSection from '../../components/sections/RandomCards'
import SliderSection from '../../components/sections/SliderSection'
import OfferSliderRepository from '../../repositories/OfferSliderRepository'
import gc from '../../utils/gc'
export default {
  name: 'RandomOffers',
  components: { SliderSection, RandomSection },
  data () {
    return {
      fetched: false,
      offerSliderRepo: new OfferSliderRepository(),
      info: {
        sliderType: 'cardsMiniSlider',
        main: { sectionId: 'random_offers', cardType: 'offer', title: this.$t('randomOffers.title'), description: this.$t('randomOffers.desc'), image: '' },
        slider: [{ type: 'random-offers', title: '', description: '', link: '', icon: '', smallIcon: '', styles: 'main' },
          { type: 'random-offers', title: '', description: '', link: '', icon: '', smallIcon: '', styles: 'second' },
          { type: 'random-offers', title: '', description: '', link: '', icon: '', smallIcon: '', styles: 'third' }]
      },
      show: false,
      error: false,
      slider: false,
      staticCard: true
    }
  },
  created () {
    this.getData()
    this.hideSlider()
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.hideSlider()
    })
  },
  methods: {
    hideSlider () {
      if (window.innerWidth > 1100) {
        this.staticCard = true
        this.slider = false
      } else if (window.innerWidth <= 1100) {
        this.staticCard = false
        this.slider = true
      }
    },
    async getData () {
      try {
        const response = await this.offerSliderRepo.get()
        if (response.status === 200) {
          this.fetched = true
          this.info.slider = []
          for (let i = 0; i < response.data.length; i++) {
            this.info.slider.push({ type: 'random-offers', title: response.data[i].title, description: response.data[i].description, link: response.data[i].link, icon: gc.baseUrl + '/customerCare' + response.data[i].largeImage, smallIcon: gc.baseUrl + '/customerCare' + response.data[i].smallImage, styles: i === 0 ? 'main' : i === 1 ? 'second' : i === 2 ? 'third' : '' })
          }
          this.show = true
        } else {
          this.error = true
          this.show = false
        }
      } catch (e) {
        this.error = true
        this.show = false
        // console.log(e)
      }
    }
  }
}
</script>

<style scoped>
#random_offers {
background: #F2F2F2;
}
  .miniSlider{
    display: none;
  }
  @media screen and (max-width: 700px) {
    .miniSlider{
      display: block;
    }
    .randomSection{
      display: none;
    }
  }
  #random_offers, #random_cards {
  }
</style>
<style>
.section-container{
  min-height: 600px;
}
</style>
